import React from "react";
import NewsletterTwentyFour from "../component/NewsletterTwentyFour";

function NewsletterTwentyFourContainer() {
  return <NewsletterTwentyFour />;
}

export default NewsletterTwentyFourContainer;
